// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ManagmentPanelLayout_componentWrapper__7QY8b","content":"ManagmentPanelLayout_content__wksh+"};